import { defineMessages } from 'react-intl';

export default defineMessages({
    customizeThePortal: {
        defaultMessage: 'Customize the portal',
        description: 'Sidebar back button message to go back to index route',
        id: 'cv.portal.simplified.portal.settings.sidebar.back.button.message',
    },
});
